import React from "react";
import { Box, Grid } from "@material-ui/core";
import Heading from "./Heading";
import { InputFields } from "./InputFields";

type Props = {
  children?: React.ReactNode;
  index: any;
  value: any;
};

export function AddContainerYardRow({ value, index, ...other }: Props): React.ReactElement {
  const pageHeading = "Add Container Yard Row";

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>
          <Box borderColor="grey.200">
            <Heading heading={pageHeading} />
            <Box borderTop={2} mb={1} borderColor="grey.200"></Box>
            <Grid container direction="row">
              <Grid item xs={12} md={12}>
                {/* Conent Start */}
                <InputFields />
                {/* Conent End */}
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </div>
  );
}
